var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.record)?_c('div',[(_vm.rsettings[0].settings.cteacher)?_c('span',[_vm._v("Class Teacher: "),_c('strong',[_vm._v(_vm._s(_vm.record.class_teacher_name))])]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }